import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IReagendamentoProps } from "../../../../types/agendamento";

export const useReagendar = () => {
  return useMutation({
    mutationFn: (data: IReagendamentoProps) => {
      const { uuidAgendamento, ...rest } = data;
      return Agendamento.reagendar({ uuid: uuidAgendamento, props: rest });
    },
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
